import { SessionsService } from "@/types/services/sessions";
import apiProxy from "@/util/api-proxy";

export const sessionsService: SessionsService = {
  getLinkedSession: async getLinkedSessionRequest =>
    await apiProxy.post(`session/getLinkedSession`, getLinkedSessionRequest),
};
